(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('pickJobGrpBatchAddr', {
        templateUrl: 'views/components/views/pickJobGrpBatchAddr/pickJobGrpBatchAddr.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'pickJobGrpBatchAddrService', function ($stateParams, stateService, utilityService, translateService, modalService, pickJobGrpBatchAddrService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockTransferKeyno = $stateParams.stocktransfer_keyno;
            let runProgress = '';

            let progressInfo = {
                label: '',
                plabel: '',
                field: '',
                remField: '',
                min: 0,
                max: 100,
                step: 0,
                finishclose: ''
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                gridReady: false,
                setting: {},
                addingSelected: false
            };

            vm.grid = {
                dataTask: {
                    rememberId: '',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        { key: 'is_selected' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false
                    },
                    onDataSourceChanges: function (e) {
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: '100%',
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    //persistSelection: false,
                    filterable: false
                },
                optionfunc: null,
                gridfunc: null
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await pickJobGrpBatchAddrService.getPickJobGroupBatchAddress({ stocktransfer_keyno: stockTransferKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
                }

                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
                    vm.grid.dataTask.loadData = {
                        method: vm.model.setting.p2_datatask_keyno,
                        parameters: vm.model.setting
                    };

                    vm.model.gridReady = true;

                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
                }
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            function activateProgress(items) {
                let increment = 1, skip = 0, failed = 0, step = 0;
                progressInfo.step = 0;

                function doStep() {
                    setTimeout(() => {
                        modalService.progressInfo.finishclose = '0';

                        if (runProgress === 'ABORT') return;

                        if (progressInfo.step >= progressInfo.max) {
                            return;
                        }

                        step = progressInfo.step + skip + failed;
                        progressInfo.field = 'ID: ' + items[step].requisition_no;
                        modalService.progressInfo.field = progressInfo.field;

                        pickJobGrpBatchAddrService.addRequisition({
                            stocktransfer_keyno: vm.model.setting.stocktransfer_keyno,
                            requisition_no: items[step].requisition_no
                        }).then((response) => {
                            if (response[0] && response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();
                                            vm.model.addingSelected = false;
                                            modalService.progressInfo.finishclose = '1';
                                            runProgress = 'ABORT';
                                            modalService.progressInfo.abortclose = true;

                                            doStep();
                                        }
                                    }]
                                });
                            } else {
                                progressInfo.step += increment;
                                modalService.progressInfo.step = progressInfo.step;
                                modalService.progressInfo.finishclose = progressInfo.finishclose;

                                doStep();
                            }
                        });
                    });
                }

                doStep();
            }

            vm.addSelected = function () {
                vm.model.addingSelected = true;
                runProgress = 'START';
                progressInfo.label = 'progressbar';
                //progressInfo.plabel = 'progressbar';
                progressInfo.field = '';
                //progressInfo.remField = '';
                //progressInfo.min = 0;
                progressInfo.max = 0;
                progressInfo.step = 0;
                progressInfo.finishclose = '1';
                progressInfo.abortclose = false;

                let allData = vm.grid.gridfunc.getAllRows();
                let currentData = [];

                allData.forEach((item) => {
                    if (item.is_selected && item.is_selected === true) {
                        currentData.push(item);
                    }
                });

                progressInfo.max = currentData.length;

                activateProgress(currentData);

                modalService.showProgress(progressInfo).then(function (value) {
                    runProgress = value;

                    if (runProgress === 'ABORT') {
                        vm.model.addingSelected = false;
                        loadGrid();
                    } else if (runProgress === 'FINISH') {
                        vm.model.addingSelected = false;
                        stateService.back();
                    }
                });
            }

            // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                loadGrid();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
